export default __webpack_public_path__ + "static/media/Hyderabad.d247620f.webp";